// Section components for the wedding site

const { useState, useEffect, useRef } = React;

// ---------- HERO ----------
window.Hero = ({ layout = 'centered', palette }) => {
  const names = ['Naïla', 'Fabrice'];
  if (layout === 'split') {
    return (
      <section className="hero hero--split" data-screen-label="Hero">
        <div className="hero-split__left">
          <div className="hero-overline">Nous nous marions</div>
          <h1 className="hero-names hero-names--stack">
            <span>Naïla</span>
            <em className="amp">&amp;</em>
            <span>Fabrice</span>
          </h1>
          <div className="hero-date-line">
            <span>Samedi</span>
            <strong>10 Avril 2027</strong>
            <span>Provence, France</span>
          </div>
          <a href="#rsvp" className="btn btn--primary">Répondre à l'invitation</a>
        </div>
        <div className="hero-split__right">
          <OliveSprig style={{ width: '100%', height: '100%' }} stroke={palette.olive} />
        </div>
      </section>);

  }
  if (layout === 'minimal') {
    return (
      <section className="hero hero--minimal" data-screen-label="Hero">
        <div className="hero-overline">— Save the date —</div>
        <h1 className="hero-names hero-names--tight">Naïla <em className="amp">&amp;</em> Fabrice</h1>
        <div className="hero-date">10 · 04 · 2027</div>
        <div className="hero-place">Le Hameau de Valouse · Valouse</div>
        <a href="#rsvp" className="btn btn--ghost">Répondre</a>
      </section>);

  }
  // centered (default)
  return (
    <section className="hero hero--centered" data-screen-label="Hero">
      <LavenderStem className="hero-botanical hero-botanical--left" stroke={palette.olive} accent={palette.wisteria} />
      <LavenderStem className="hero-botanical hero-botanical--right" stroke={palette.olive} accent={palette.wisteria} />
      <div className="hero-inner">
        <div className="hero-overline">— Samedi 10 avril 2027 —</div>
        <h1 className="hero-names">
          Naïla <em className="amp">&amp;</em> Fabrice
        </h1>
        <Divider color={palette.olive} />
        <p className="hero-sub">
          Nous serions ravis de vous accueillir<br />
          au <strong>Hameau de Valouse</strong>, en Drôme provençale,<br />
          pour célébrer notre mariage.
        </p>
        <div className="hero-counter" id="countdown"></div>
        <a href="#rsvp" className="btn btn--primary">Répondre à l'invitation</a>
      </div>
    </section>);

};

// ---------- SCHEDULE (placeholder "Informations à venir") ----------
window.Schedule = () => {
  return (
    <section className="section section--schedule" id="schedule" data-screen-label="Schedule">
      <SectionHeader overline="Le déroulé" title="Le jour J" kicker="Samedi 10 avril 2027" />
      <div className="coming-soon">
        <img src="assets/img/info-soon.webp?v=1" alt="Informations à venir" loading="lazy" />
      </div>
    </section>);

};

// ---------- VENUE ----------
window.Venue = ({ palette }) => {
  return (
    <section className="section section--venue" id="venue" data-screen-label="Venue">
      <SectionHeader overline="Le lieu" title="Hameau de Valouse" kicker="Valouse · Drôme provençale" />
      <div className="venue-grid">
        <div className="venue-card">
          <OliveSprig className="venue-card__sprig" />
          <div className="venue-card__label">Adresse</div>
          <div className="venue-card__body">
            Hameau de Valouse<br />
            Grange Basse<br />
            26110 Valouse<br />
            France
          </div>
          <a className="linklet" href="https://maps.google.com/?q=Hameau+de+Valouse+Grange+Basse+26110+Valouse" target="_blank" rel="noopener">Ouvrir dans Maps ↗</a>
        </div>
        <div className="venue-map">
          <iframe
            title="Carte — Hameau de Valouse"
            src="https://maps.google.com/maps?q=Hameau+de+Valouse,+26110+Valouse&z=14&output=embed"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            allowFullScreen
          />
        </div>
      </div>
    </section>);

};

// ---------- TRAVEL ----------
const TRAVEL_ICONS = {
  car: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M5 11l1.6-3.8A2 2 0 0 1 8.4 6h7.2a2 2 0 0 1 1.8 1.2L19 11" />
      <rect x="3" y="11" width="18" height="5" rx="1.6" />
      <circle cx="7.5" cy="16.4" r="1.5" />
      <circle cx="16.5" cy="16.4" r="1.5" />
    </svg>
  ),
  train: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="6" y="3" width="12" height="13" rx="3.5" />
      <rect x="8.4" y="5.6" width="7.2" height="3.2" rx="1" />
      <circle cx="9.6" cy="12.4" r="0.85" fill="currentColor" stroke="none" />
      <circle cx="14.4" cy="12.4" r="0.85" fill="currentColor" stroke="none" />
      <path d="M8.5 16l-2 4" />
      <path d="M15.5 16l2 4" />
    </svg>
  ),
  bed: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M2.5 9v7.5" />
      <path d="M2.5 12.5h11.5a5.5 5.5 0 0 1 5.5 5.5" />
      <path d="M2.5 16.5h17" />
      <path d="M2.5 16.5v3" />
      <path d="M19.5 18v1.8" />
      <path d="M6 12.5v-1a1.6 1.6 0 0 1 1.6-1.6h2.8A1.6 1.6 0 0 1 12 11.5v1" />
    </svg>
  ),
};

window.Travel = () => {
  const items = [
  {
    icon: 'car',
    title: 'Par la route',
    lines: [
    'Autoroute A7, sortie n°19 (Bollène) puis ~45 min',
    'Parking gratuit sur place']

  },
  {
    icon: 'train',
    title: 'En train',
    lines: [
    'Gare TGV d\'Avignon (1h) ou Montélimar (45 min)',
    'Nous organiserons des navettes si nécessaire']

  },
  {
    icon: 'bed',
    title: 'Où dormir',
    lines: [
    'Hameau de Valouse — chambres sur place (réservées)']

  }];

  return (
    <section className="section section--travel" id="travel" data-screen-label="Travel">
      <SectionHeader overline="Venir & dormir" title="Accès & hébergement" kicker="Tout ce qu'il vous faut pour arriver sereinement" />
      <div className="travel-grid">
        {items.map((it, i) =>
        <div key={i} className="travel-card">
            <OliveSprig className="travel-card__sprig" />
            <div className="travel-card__head">
              <span className="travel-card__icon">{TRAVEL_ICONS[it.icon]}</span>
              <span className="travel-card__number">0{i + 1}</span>
            </div>
            <h3 className="travel-card__title">{it.title}</h3>
            <ul className="travel-card__lines">
              {it.lines.map((l, j) => <li key={j}>{l}</li>)}
            </ul>
          </div>
        )}
      </div>
    </section>);

};

// ---------- RSVP TEASER (on homepage) ----------
window.RsvpTeaser = () => {
  return (
    <section className="section section--rsvp" id="rsvp" data-screen-label="RSVP">
      <SectionHeader overline="Votre réponse" title="RSVP" kicker="Merci de répondre avant le 1er décembre 2026" />
      <div className="rsvp-lookup">
        <p className="rsvp-lookup__msg">
          Vous avez reçu un <strong>lien personnel</strong> avec votre invitation&nbsp;:
          cliquez dessus pour accéder directement à votre formulaire de réponse,
          déjà à votre nom.
        </p>
        <p className="rsvp-lookup__hint">
          Lien égaré&nbsp;? Contactez-nous par téléphone, nous vous le renverrons.
        </p>
      </div>
    </section>);

};

// ---------- FAQ ----------
window.Faq = () => {
  const items = [
  {
    q: 'Où puis-je me garer ?',
    a: [`Plusieurs parkings sont disponibles sur le domaine. Suivez simplement la signalisation ou les indications données par les mariés à votre arrivée.`]
  },
  {
    q: 'Puis-je recharger un véhicule électrique ?',
    a: [`Oui, une prise est disponible gratuitement sur le domaine.`]
  },
  {
    q: 'Des camping-cars ou vans peuvent-ils stationner sur place ?',
    a: [`Oui, sous réserve de respecter les emplacements prévus. En revanche, il n'y a pas de borne de vidange ni de remplissage d'eau.`]
  },
  {
    q: 'Où vais-je dormir ?',
    a: [
    `Nous attribuerons une chambre à chaque invité séjournant sur place. Vous recevrez votre clé à votre arrivée sur le domaine. Nous vous remercions également de libérer votre chambre avant 12 h le lendemain afin de faciliter l'organisation du domaine.`,
    `Si vous préférez dormir ailleurs (hôtel, gîte, camping, etc.), merci de nous en informer à l'avance afin que nous puissions organiser au mieux la répartition des chambres.`]
  },
  {
    q: 'À quelle heure puis-je arriver ?',
    a: [
    `Vous êtes les bienvenus sur le domaine à partir de 14 h pour vous installer tranquillement et vous préparer avant la cérémonie. Les clés de votre chambre vous seront remises à votre arrivée (nous vous indiquerons à qui vous adresser).`,
    `En revanche, merci d'être à l'heure pour la cérémonie afin que nous puissions profiter ensemble de cette belle journée dès les premiers instants !`]
  },
  {
    q: 'Le domaine est-il accessible aux personnes à mobilité réduite ?',
    a: [`La salle de réception et les sanitaires sont accessibles. En revanche, le domaine étant construit à flanc de colline, certaines zones et les hébergements comportent des escaliers.`]
  },
  {
    q: 'Les enfants sont-ils les bienvenus ?',
    a: [
    `Pour profiter pleinement de cette journée, nous préférerions célébrer ce mariage entre adultes.`,
    `Toutefois, si vous n'avez pas de solution de garde, n'hésitez pas à nous en parler. Selon le nombre d'enfants concernés, nous pourrons organiser la présence d'une nounou sur place (la prestation restera à la charge des parents).`,
    `Les couchages ayant été prévus uniquement pour les adultes, nous ne pourrons malheureusement pas fournir de lit supplémentaire. Si votre enfant est présent, il faudra donc prévoir son couchage.`,
    `Enfin, pour des raisons de sécurité et afin que la soirée dansante puisse se dérouler dans les meilleures conditions, les enfants ne seront plus autorisés dans la salle de réception à partir de 22 h.`]
  },
  {
    q: 'Les animaux sont-ils autorisés ?',
    a: [`Les animaux ne sont pas autorisés dans le domaine.`]
  },
  {
    q: 'Y a-t-il des règles particulières à respecter ?',
    a: [`Oui, afin de préserver le domaine et de respecter le voisinage, quelques règles sont à suivre :`],
    list: [
    `Les feux d'artifice, fumigènes, lanternes, confettis, faux pétales et autres décorations pouvant présenter un risque d'incendie ou générer des déchets sont interdits.`,
    `Vous pourrez profiter des espaces extérieurs toute la journée. En revanche, à partir de 22 h, merci de limiter le bruit afin de respecter le voisinage.`,
    `Il est strictement interdit de fumer ou de vapoter dans les chambres, la salle de réception, l'office et le champ de la cérémonie. Des cendriers sont mis à votre disposition à l'extérieur.`,
    `Il est strictement interdit de sortir le mobilier intérieur (salle de réception, chambres, etc.) vers les espaces extérieurs.`],
    after: [`Merci à tous de contribuer au bon déroulement de ce week-end et au respect des lieux.`]
  }];

  const [open, setOpen] = useState(0);
  return (
    <section className="section section--faq" id="faq" data-screen-label="FAQ">
      <SectionHeader overline="Vos questions" title="FAQ" kicker="Si la réponse n'est pas ici, contactez-nous par téléphone" />
      <div className="faq">
        {items.map((it, i) =>
        <div key={i} className={`faq__item ${open === i ? 'is-open' : ''}`}>
            <button className="faq__q" onClick={() => setOpen(open === i ? -1 : i)} aria-expanded={open === i}>
              <span className="faq__num">{String(i + 1).padStart(2, '0')}</span>
              <span className="faq__text">{it.q}</span>
              <span className="faq__chev" aria-hidden="true">{open === i ? '—' : '+'}</span>
            </button>
            <div className="faq__a">
              <div className="faq__a-inner">
                {it.a.map((p, k) => <p key={k}>{p}</p>)}
                {it.list &&
                <ul className="faq__list">
                    {it.list.map((li, k) => <li key={k}>{li}</li>)}
                  </ul>}
                {it.after && it.after.map((p, k) => <p key={k}>{p}</p>)}
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="faq-contact">
        Une autre question&nbsp;? Contactez-nous par téléphone.
      </div>
    </section>);

};

// ---------- Shared ----------
window.SectionHeader = ({ overline, title, kicker }) =>
<header className="section-header">
    <div className="section-header__overline">— {overline} —</div>
    <h2 className="section-header__title">{title}</h2>
    {kicker && <div className="section-header__kicker">{kicker}</div>}
  </header>;


window.Footer = ({ palette }) =>
<footer className="footer">
    <Monogram size={80} color={palette.olive} />
    <div className="footer__line">Naïla &amp; Fabrice · 10 avril 2027 · Provence</div>
    <div className="footer__line footer__line--small"></div>
  </footer>;
